export class SharedPathSegments {
  static auth(): string {
    return `auth`;
  }
  static resetPassword(): string {
    return `reset-password`;
  }
  static setNewPassword(): string {
    return `set-new-password`;
  }
  static layoutRoot(): string {
    return ``;
  }
}
